import React, { ReactNode } from 'react';

import { StyledTabs } from './Tabs.styles';

import { TabProps, TabsProps } from './Tabs.types';

const Tabs = ({
  tabs = [],
  activeTabIndex,
  handleChangeTab,
  componentClassname = 'tabs',
  customClassnames = '',
  customStyle = '',
  tabLabelWrapper = ({ children }: { children: ReactNode }) => children,
  ...props
}: TabsProps) => {
  const activeContent = tabs?.find(
    (_tab: TabProps, index: number) => index === activeTabIndex,
  ).content;

  return (
    <StyledTabs
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {tabLabelWrapper({
        children: (
          <div className={`${componentClassname}__tab-label-list`}>
            {tabs?.map((tab: TabProps, index: number) => (
              <button
                key={`tab-label-key-${index}`}
                className={`${componentClassname}__tab-label ${
                  activeTabIndex === index &&
                  `${componentClassname}__tab-label--active`
                }`}
                onClick={() => handleChangeTab(index)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        ),
      })}

      {activeContent && (
        <div className={`${componentClassname}__tab-content`}>
          {activeContent}
        </div>
      )}
    </StyledTabs>
  );
};
Tabs.displayName = 'Tabs';

export default Tabs;
